import React from "react";
import { renderComponent } from "utils/commonUtils";
import EmployeeDocumentsComponent from "./EmployeeDocumentsComponent";

const EmployeeDocuments = () => {
  return renderComponent(<EmployeeDocumentsComponent />);
};

export default EmployeeDocuments;
